<template>
  <div>
    <v-row>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.col"
          label="COL"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.ldl"
          label="LDL"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.hdl"
          label="HDL"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.tgc"
          label="TGC"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.gluc"
          label="Gluc."
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import evolucionJsonMixin from "../../../../mixins/evolucionJsonMixin";
export default {
  data() {
    return {
      values: {
        col: null,
        ldl: null,
        hdl: null,
        gluc: null,
        tgc: null,
      },
    };
  },
  mixins: [evolucionJsonMixin],
  computed: {
    camposRequeridos() {
      return false;
    },
    defaultValues() {
      return {
        col: null,
        ldl: null,
        hdl: null,
        gluc: null,
        tgc: null,
      };
    },
  },
  created() {
    this.values = { ...this.defaultValues };
  },
};
</script>
